module.exports = "\r\n\r\n<game-component *ngIf=\"isGameRunning\" [gameData]=\"restoredGameData\" (quit)=\"restoredGameData = null; isGameRunning = false\" [(teams)]=\"teams\"></game-component>\r\n\r\n<set-up-component *ngIf=\"!isGameRunning\" (createGame)=\"onCreateGame()\"></set-up-component>\r\n\r\n<!--<scaling-component></scaling-component>-->\r\n\r\n<portrait-block-component></portrait-block-component>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main